import React from "react";

import "../../css/documentView.css";
import { DocumentData } from "../../util/interfaces/DocumentData";

interface DocumentsGridProps {
  documentDetails: DocumentData;
}

export const DetailView: React.FC<DocumentsGridProps> = ({ documentDetails }) => {
  return (
    <>
      <div className="flex flow-column" style={{ gap: "8px" }}>
        <div>
          <span>
            <b>File: </b>
          </span>
          <span>{documentDetails.documentName}</span>
        </div>
        <div>
          <span>
            <b>Category: </b>
          </span>
          <span>{documentDetails.category}</span>
        </div>
        <div>
          <span>
            <b>File Type: </b>
          </span>
          <span>{documentDetails.fileType}</span>
        </div>
        <div>
          <span>
            <b>Uploaded By: </b>
          </span>
          <span>{documentDetails.uploadedBy}</span>
        </div>
        <div>
          <span>
            <b>Uploaded Date: </b>
          </span>
          <span>{documentDetails.uploaded}</span>
        </div>
      </div>
      <div className="document-view-doc-details-body-content-separator" />
      <div className="flex flow-column" style={{ gap: "8px" }}>
        <span>
          <b>Metadata: </b>
        </span>
        <span>{documentDetails?.metadata}</span>
      </div>
    </>
  );
};
